export default __webpack_public_path__ + "static/media/christmas-header.91b62543.png";